import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { Campaign } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GetCampaignsFilter } from '../../endpoints/campaigns';

export const getCampaigns = async (
  params: GetCollectionQueryParams<Campaign, GetCampaignsFilter>,
): Promise<ApiCollectionResponse<Campaign>> => {
  return await tinctApi.campaigns.getCampaigns(params);
};

export const useGetCampaigns = (
  params: GetCollectionQueryParams<Campaign, GetCampaignsFilter>,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<Campaign>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['campaigns', params],
    queryFn: () => getCampaigns(params),
    ...options,
  });
